import { AuthService } from '../services';
import { createFormData, getCookie } from '.';
import toast from 'react-hot-toast';

export const fetchWrapper = {
  get: request('GET'),
  post: request('POST'),
  patch: request('PATCH'),
  put: request('PUT'),
  delete: request('DELETE')
};

function request(method) {
  return async (url, body) => {
    const requestOptions = { method, headers: authHeader() };
    if (body) {
      if (body?.hasFile) {
        requestOptions.body = createFormData(body);

      } else {
        requestOptions.headers['Content-Type'] = 'application/json';
        requestOptions.body = JSON.stringify(body);
      }
    }
    return fetch(url, requestOptions)
      .then(handleResponse)
      .catch(err => {
        if (!body?.hideError) toast.error(err);
        return Promise.reject(err);
      });
  }
}

function authHeader() {
  const token = getCookie(process.env.REACT_APP_SESSION_NAME);
  return !!token
    ? { Authorization: `Bearer ${token}` }
    : {};
}

async function handleResponse(response) {
  const isJson = response.headers?.get('content-type')?.includes('application/json');
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    if ([401].includes(response?.status)) {
      console.log('Cierre de sesión automático')
      AuthService.removeSession();
    }

    const error = (data && data.error) || response.status_text;
    return Promise.reject(error);
  }

  return data;
}